import { defineMessages } from 'react-intl';

const scope = 'app.containers.Statistics.Usage';

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Usage',
    },
});
